/* TLY free-gift picker popup (clean-room) v2.3: no dimming, no preselect, X removes a pick. API: TLY_GIFTS_POPUP.open({ruleId,gifts,required,selected,defaultTwin,mode,triggerTitle,onConfirm,onDismiss}) */
(function () {
  'use strict';
  if (window.TLY_GIFTS_POPUP) return;

  var imgCache = {};   // handle -> Promise<string|null>
  var current = null;  // {root, prevFocus, opts, sel, done}

  function clean(t) { return String(t || '').replace(/\s*\(Free Gift\)\s*$/i, ''); }
  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function sum(o) { return Object.keys(o).reduce(function (s, k) { return s + (o[k] || 0); }, 0); }

  // Real product's CURRENT photo: /products/<handle>.js -> featured_image. Fallback: twin image.
  function realImage(handle) {
    if (!handle) return Promise.resolve(null);
    if (!imgCache[handle]) {
      imgCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { return p.featured_image || (p.images && p.images[0]) || null; })
        .catch(function () { return null; });
    }
    return imgCache[handle];
  }
  function sized(url) {
    if (!url) return url;
    var u = String(url); if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=400';
  }
  function twinImage(g) {
    if (g.image) return Promise.resolve(g.image);
    if (g.twin_handle) {
      return fetch('/products/' + encodeURIComponent(g.twin_handle) + '.js').then(function (r) { return r.json(); })
        .then(function (p) { return p.featured_image || null; }).catch(function () { return null; });
    }
    return Promise.resolve(null);
  }

  function open(opts) {
    if (current) close(false);
    var required = Math.max(1, opts.required || 1);
    var multi = required > 1;
    var sel = {};
    var seed = opts.selected || {};
    Object.keys(seed).forEach(function (k) { if (seed[k] > 0) sel[k] = seed[k]; });

    var prevFocus = document.activeElement;
    var root = el('div', 'tly-gp', { 'data-tly-gp': '1' });
    var back = el('div', 'tly-gp__back');
    var dlg = el('div', 'tly-gp__dlg', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'tly-gp-title', 'aria-describedby': 'tly-gp-sub' });
    var closeBtn = el('button', 'tly-gp__x', { type: 'button', 'aria-label': 'Close and keep the default gift' });
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg>';
    var h = el('h2', 'tly-gp__title', { id: 'tly-gp-title' }); h.textContent = 'You earned a FREE gift';
    var sub = el('p', 'tly-gp__sub', { id: 'tly-gp-sub' });
    sub.textContent = opts.triggerTitle ? ('Pick your gift with your ' + opts.triggerTitle + '.') : 'Pick your free gift.';
    var counter = el('p', 'tly-gp__count', { 'aria-live': 'polite' });
    var grid = el('div', 'tly-gp__grid');
    var ok = el('button', 'tly-gp__ok', { type: 'button' }); ok.textContent = 'ADD MY FREE GIFT';

    var cards = {};
    opts.gifts.forEach(function (g) {
      var id = String(g.twin_variant_id);
      var card = el('div', 'tly-gp__card');
      var pick = el('button', 'tly-gp__pick', { type: 'button', 'aria-pressed': 'false' });
      var imgBox = el('span', 'tly-gp__img');
      var ph = el('span', 'tly-gp__ph', { 'aria-hidden': 'true' }); ph.textContent = '🎁';
      imgBox.appendChild(ph);
      var tag = el('span', 'tly-gp__tag'); tag.textContent = 'SELECTED';
      var name = el('span', 'tly-gp__name'); name.textContent = clean(g.title);
      pick.appendChild(imgBox); pick.appendChild(tag); pick.appendChild(name);
      card.appendChild(pick);
      var unx = el('button', 'tly-gp__unx', { type: 'button', 'aria-label': 'Remove ' + clean(g.title) });
      unx.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" fill="none"/></svg>';
      unx.addEventListener('click', function (e) { e.stopPropagation(); delete sel[id]; paint(); pick.focus(); });
      card.appendChild(unx);
      var step = null, minus, plus, qty;
      if (multi) {
        step = el('div', 'tly-gp__step', { role: 'group', 'aria-label': 'Quantity of ' + clean(g.title) });
        minus = el('button', 'tly-gp__sb', { type: 'button', 'aria-label': 'Remove one ' + clean(g.title) }); minus.textContent = '−';
        qty = el('span', 'tly-gp__sq', { 'aria-live': 'polite' });
        plus = el('button', 'tly-gp__sb', { type: 'button', 'aria-label': 'Add one ' + clean(g.title) }); plus.textContent = '+';
        step.appendChild(minus); step.appendChild(qty); step.appendChild(plus);
        card.appendChild(step);
        minus.addEventListener('click', function () { if ((sel[id] || 0) > 0) { sel[id]--; if (!sel[id]) delete sel[id]; paint(); } });
        plus.addEventListener('click', function () { if (sum(sel) < required) { sel[id] = (sel[id] || 0) + 1; paint(); } });
        pick.addEventListener('click', function () { if ((sel[id] || 0) === 0 && sum(sel) < required) { sel[id] = 1; paint(); } });
      } else {
        pick.addEventListener('click', function () { sel = {}; sel[id] = 1; paint(); });
      }
      cards[id] = { card: card, pick: pick, tag: tag, qty: qty, minus: minus, plus: plus };
      grid.appendChild(card);
      // photo: real product's current photo, else twin image
      realImage(g.source_handle).then(function (u) { return u || twinImage(g); }).then(function (u) {
        if (!u) return;
        var im = el('img', '', { alt: '' });
        im.onload = function () { if (ph.parentNode) ph.remove(); imgBox.appendChild(im); };
        im.onerror = function () { twinImage(g).then(function (t) { if (t && t !== u) im.src = sized(t); }); };
        im.src = sized(u);
      });
    });

    function paint() {
      var total = sum(sel);
      Object.keys(cards).forEach(function (id) {
        var c = cards[id]; var q = sel[id] || 0; var on = q > 0;
        c.card.classList.toggle('is-on', on);
        c.pick.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (c.qty) { c.qty.textContent = q; c.minus.disabled = q === 0; c.plus.disabled = total >= required; }
      });
      if (multi) counter.textContent = total + ' of ' + required + ' picked';
      ok.disabled = total !== required;
    }

    dlg.appendChild(closeBtn); dlg.appendChild(h); dlg.appendChild(sub);
    if (multi) dlg.appendChild(counter);
    dlg.appendChild(grid); dlg.appendChild(ok);
    root.appendChild(back); root.appendChild(dlg);
    document.body.appendChild(root);
    document.documentElement.classList.add('tly-gp-open');
    paint();

    var st = { root: root, dlg: dlg, prevFocus: prevFocus, opts: opts, done: false, getSel: function () { return sel; } };
    current = st;

    ok.addEventListener('click', function () { if (sum(sel) === required) finish(true); });
    closeBtn.addEventListener('click', function () { finish(false); });
    back.addEventListener('click', function () { finish(false); });
    st.keydown = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); finish(false); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(dlg.querySelectorAll('button:not([disabled])'), function (b) { return b.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!dlg.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', st.keydown, true);
    // keep focus inside even if something else grabs it
    st.focusin = function (e) { if (!dlg.contains(e.target)) { var b = dlg.querySelector('button'); if (b) b.focus(); } };
    document.addEventListener('focusin', st.focusin, true);

    setTimeout(function () {
      var target = dlg.querySelector('.tly-gp__card.is-on .tly-gp__pick') || dlg.querySelector('.tly-gp__pick');
      if (target) target.focus();
    }, 30);

    function finish(confirmed) {
      if (st.done) return; st.done = true;
      var chosen = {}; Object.keys(sel).forEach(function (k) { if (sel[k] > 0) chosen[k] = sel[k]; });
      teardown(st);
      if (confirmed) { if (opts.onConfirm) opts.onConfirm(chosen); }
      else if (opts.onDismiss) opts.onDismiss();
    }
    st.finish = finish;
    return { close: function () { finish(false); } };
  }

  function teardown(st) {
    document.removeEventListener('keydown', st.keydown, true);
    document.removeEventListener('focusin', st.focusin, true);
    if (st.root.parentNode) st.root.parentNode.removeChild(st.root);
    document.documentElement.classList.remove('tly-gp-open');
    if (current === st) current = null;
    try { if (st.prevFocus && st.prevFocus.focus) st.prevFocus.focus(); } catch (e) { /* ignore */ }
  }
  function close(confirmed) { if (current) current.finish(!!confirmed); }

  window.TLY_GIFTS_POPUP = { open: open, close: close, isOpen: function () { return !!current; } };
  document.dispatchEvent(new CustomEvent('tly:gifts:popup-ready'));
})();
